<template>
  <el-dialog
      v-model="dialogVisible"
      title="导入禁书"
      width="420px"
      :close-on-click-modal="false"
      :before-close="handleClose"
  >
    <div class="main-container">
      <div class="upload-row flex a-c">
        <el-upload
            action="action"
            :http-request="uploadFile"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept=".xls,.xlsx"
            :disabled="uploadLoading || confirmLoading"
        >
          <el-button type="primary" size="small" :loading="uploadLoading">点击上传</el-button>
        </el-upload>
        <el-button
            style="margin-left: 25px"
            type="primary"
            size="small"
            @click="downloadTemplate"
        >
          下载模板
        </el-button>
      </div>
      <div v-if="fileName" class="file-name">已选择：{{ fileName }}</div>
      <div class="upload-tip">只能上传 xls、xlsx文件，且不超过5M</div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="confirmHandler">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {ref} from 'vue'
import {uploadMultipartFile, importResourceIsbn} from "@/js/network/main"
import {MessageBox} from "@/js/utils/commonJs";
import {ElMessage} from "element-plus";

// 禁书导入模板地址
const TEMPLATE_URL = 'https://miniopreview.resourcemap.com.cn/kc-unify/web/禁书导入模板.xlsx'

export default {
  setup(props, {emit}) {
    const dialogVisible = ref(false)
    const uploadLoading = ref(false)
    const confirmLoading = ref(false)
    const filePath = ref('')
    const fileName = ref('')

    // 打开弹窗
    const init = () => {
      filePath.value = ''
      fileName.value = ''
      dialogVisible.value = true
    }

    // 关闭并清空
    const handleClose = () => {
      filePath.value = ''
      fileName.value = ''
      dialogVisible.value = false
    }

    // 上传前校验
    const beforeUpload = (rawFile) => {
      const ext = rawFile.name.substring(rawFile.name.lastIndexOf('.') + 1).toLowerCase()
      if (['xls', 'xlsx'].indexOf(ext) === -1) {
        ElMessage.error('上传文件只能是 xls、xlsx 格式!')
        return false
      }
      if (rawFile.size / 1024 / 1024 >= 5) {
        ElMessage.error('上传文件大小不能超过 5MB!')
        return false
      }
      return true
    }

    // 上传文件，拿到路径后待确认再导入
    const uploadFile = (param) => {
      const form = new FormData()
      form.append('file', param.file)
      uploadLoading.value = true
      uploadMultipartFile(form).then((res) => {
        uploadLoading.value = false
        if (!res || !res.success) {
          MessageBox.error(res?.msg || '文件上传失败')
          return
        }
        filePath.value = res.data?.url || ''
        fileName.value = param.file?.name || res.data?.originalName || ''
        if (!filePath.value) {
          MessageBox.error('上传成功但未返回文件路径')
          return
        }
        ElMessage.success('上传成功!')
      }).catch((error) => {
        uploadLoading.value = false
        console.log(error, 'catchError')
      })
    }

    // 下载导入模板
    const downloadTemplate = () => {
      const a = document.createElement('a')
      a.setAttribute('href', TEMPLATE_URL)
      a.setAttribute('download', '禁书导入模板')
      a.setAttribute('target', '_blank')
      a.click()
    }

    // 确认导入
    const confirmHandler = () => {
      if (!filePath.value) {
        ElMessage.warning('请先上传文件!')
        return
      }
      confirmLoading.value = true
      importResourceIsbn({filePath: filePath.value}).then((res) => {
        confirmLoading.value = false
        if (!res || !res.success) {
          MessageBox.error(res?.msg || '导入失败')
          return
        }
        const data = res.data || {}
        const totalCount = data.total ?? 0
        const successCount = data.successCount ?? 0
        const existCount = data.existCount ?? 0
        MessageBox.success(`成功导入 ${successCount} 条，已存在 ${existCount} 条，共 ${totalCount} 条`)
        handleClose()
        emit('success')
      }).catch((error) => {
        confirmLoading.value = false
        console.log(error, 'catchError')
      })
    }

    return {
      dialogVisible,
      uploadLoading,
      confirmLoading,
      fileName,
      init,
      handleClose,
      beforeUpload,
      uploadFile,
      downloadTemplate,
      confirmHandler,
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer button:first-child {
  margin-right: 10px;
}

.main-container {
  .upload-row {
    margin-bottom: 8px;
  }

  .file-name {
    margin-top: 8px;
    font-size: 13px;
    color: #6573A2;
    word-break: break-all;
  }

  .upload-tip {
    margin-top: 12px;
    font-size: 12px;
    color: #A2A2A2;
  }
}
</style>
